/* Élie Semoun · Cactus — small interaction layer
   - reveal-on-scroll
   - shop card color swaps + hover lifestyle
*/
(function () {
  function onReady(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  onReady(function () {
    document.body.classList.add("cactus-theme");

    // Reveal on scroll
    var els = document.querySelectorAll(".cactus-reveal");
    if ("IntersectionObserver" in window && els.length) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-in");
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: "-60px 0px", threshold: 0.05 }
      );
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add("is-in"); });
    }

    // Header: scrolled state
    var header = document.querySelector("[data-cactus-header]");
    if (header) {
      var onScroll = function () {
        if (window.scrollY > 40) header.classList.add("is-scrolled");
        else header.classList.remove("is-scrolled");
      };
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
    }

    // Tour filter
    var tour = document.querySelector("[data-cactus-tour]");
    if (tour) {
      var btns = tour.querySelectorAll("[data-tour-filter]");
      var rows = tour.querySelectorAll("[data-tour-region]");
      var months = tour.querySelectorAll("[data-tour-month]");
      var counter = tour.querySelector("[data-tour-counter]");
      btns.forEach(function (b) {
        b.addEventListener("click", function () {
          var f = b.getAttribute("data-tour-filter");
          btns.forEach(function (x) { x.classList.toggle("is-active", x === b); });
          var visible = 0;
          rows.forEach(function (row) {
            var keep = f === "all" || row.getAttribute("data-tour-region") === f;
            row.style.display = keep ? "" : "none";
            if (keep) visible++;
          });
          months.forEach(function (m) {
            var any = m.querySelector('[data-tour-region]:not([style*="display: none"])');
            m.style.display = any ? "" : "none";
          });
          if (counter) counter.textContent = visible + " date" + (visible > 1 ? "s" : "") + " affichée" + (visible > 1 ? "s" : "");
        });
      });
    }

    // Shop card color swatches
    document.querySelectorAll("[data-cactus-card]").forEach(function (card) {
      var swatches = card.querySelectorAll("[data-swatch]");
      var images = card.querySelectorAll("[data-color-image]");
      var lifestyle = card.querySelectorAll("[data-color-lifestyle]");
      var nameEl = card.querySelector("[data-color-name]");
      function pick(idx) {
        swatches.forEach(function (s, i) { s.classList.toggle("is-active", i === idx); });
        images.forEach(function (im, i) { im.classList.toggle("is-active", i === idx); });
        lifestyle.forEach(function (im, i) { im.classList.toggle("is-active", i === idx); });
        if (nameEl) {
          var n = swatches[idx].getAttribute("data-name");
          if (n) nameEl.textContent = n;
        }
      }
      swatches.forEach(function (s, i) {
        s.addEventListener("click", function (e) { e.preventDefault(); e.stopPropagation(); pick(i); });
      });
    });

    // Newsletter UX (visual only — Shopify form posts on submit)
    document.querySelectorAll("[data-cactus-newsletter]").forEach(function (form) {
      form.addEventListener("submit", function () {
        var btn = form.querySelector("button[type=submit]");
        if (btn) btn.textContent = "...";
      });
    });

    // Mobile menu
    var menuBtn = document.querySelector("[data-cactus-menu-open]");
    var menu = document.querySelector("[data-cactus-menu]");
    var menuClose = document.querySelector("[data-cactus-menu-close]");
    function openMenu() { if (menu) menu.classList.add("is-open"); document.body.style.overflow = "hidden"; }
    function closeMenu() { if (menu) menu.classList.remove("is-open"); document.body.style.overflow = ""; }
    if (menuBtn) menuBtn.addEventListener("click", openMenu);
    if (menuClose) menuClose.addEventListener("click", closeMenu);
    if (menu) {
      menu.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", closeMenu); });
    }

    // Product cards — swatch click swaps primary/secondary images + active state
    document.querySelectorAll("[data-cactus-card]").forEach(function (card) {
      var raw = card.getAttribute("data-variant-images");
      if (!raw) return;
      var map;
      try { map = JSON.parse(raw); } catch (_) { return; }
      var primaryImg = card.querySelector("[data-cactus-img-primary]");
      var secondaryImg = card.querySelector("[data-cactus-img-secondary]");
      var nameLabel = card.querySelector("[data-color-name]");
      var swatches = card.querySelectorAll("[data-swatch]");
      swatches.forEach(function (sw) {
        ["click", "mouseenter"].forEach(function (evt) {
          sw.addEventListener(evt, function (e) {
            if (evt === "click") { e.preventDefault(); e.stopPropagation(); }
            var name = sw.getAttribute("data-name");
            var entry = map[name];
            if (!entry) return;
            if (primaryImg && entry.primary) primaryImg.src = entry.primary;
            if (secondaryImg && entry.secondary) secondaryImg.src = entry.secondary;
            // visual: active swatch
            swatches.forEach(function (s) {
              s.classList.toggle("is-active", s === sw);
              s.style.transform = s === sw ? "scale(1.1)" : "";
              s.style.borderColor = s === sw ? "var(--cactus-ink)" : "rgba(20,20,20,0.15)";
            });
            if (nameLabel && evt === "click") {
              var arrowSvg = nameLabel.querySelector("svg");
              nameLabel.firstChild.textContent = name + " ";
              if (arrowSvg) nameLabel.appendChild(arrowSvg);
            }
          });
        });
      });
    });

    // Smooth scroll on anchor links (handles header offset + same-page #anchors)
    var headerOffset = 80;
    document.addEventListener("click", function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a) return;
      var href = a.getAttribute("href");
      if (!href) return;
      var isPure = href.charAt(0) === "#";
      var url, isSamePath = false;
      try {
        url = new URL(a.href, location.href);
        isSamePath = url.pathname === location.pathname && !!url.hash;
      } catch (_) {}
      if (!(isPure || isSamePath)) return;
      var hash = isPure ? href : url.hash;
      if (hash === "#" || hash.length < 2) return;
      var target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
      window.scrollTo({ top: top, behavior: "smooth" });
      if (history.replaceState) history.replaceState(null, "", hash);
    });
  });
})();
